import { render, staticRenderFns } from "./DistrictBtns.vue?vue&type=template&id=af7744a8&"
import script from "./DistrictBtns.vue?vue&type=script&lang=js&"
export * from "./DistrictBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports